import { Spin } from "antd";
import React, { lazy, Suspense, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import Dashboard from "./dashboard";
import Purchases from "./purchases";
import Members from "./members";
import QRCodes from "./qrcodes";
import Branches from "./branches";
import Activities from "./activities";
import Employees from "./employees";
import Users from "./users";
import Reports from "./reports";
import Countries from "./countries";
import SubscriptionPackages from "./subscription-packages";
import withAdminLayout from "../../layout/withAdminLayout";

const Myprofile = lazy(() => import("../../container/profile/myProfile/Index"));
const NotFound = lazy(() => import("../../container/pages/404"));

const Admin = React.memo(() => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Suspense
      fallback={
        <div className="spin flex items-center justify-center bg-white dark:bg-dark h-screen w-full fixed z-[999] ltr:left-0 rtl:right-0 top-0">
          <Spin />
        </div>
      }
    >
      <Routes>
        <Route index path="/*" element={<Dashboard />} />

        <Route path="users/*" element={<Users />} />
        <Route path="members/*" element={<Members />} />
        <Route path="branches/*" element={<Branches />} />
        <Route path="activities/*" element={<Activities />} />
        <Route path="employees/*" element={<Employees />} />
        <Route
          path="subscription-packages/*"
          element={<SubscriptionPackages />}
        />
        <Route path="purchases/*" element={<Purchases />} />
        <Route path="reports/*" element={<Reports />} />
        <Route path="qr-codes/*" element={<QRCodes />} />
        <Route path="countries/*" element={<Countries />} />
        {/* <Route path="wallet/*" element={<Wallets />} /> */}
        <Route path="profile/myProfile/*" element={<Myprofile />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
});

export default withAdminLayout(Admin);
